import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-leaving-gate-modal',
    templateUrl: './leaving-gate-modal.component.html',
    styleUrls: ['./leaving-gate-modal.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class LeavingGateModalComponent extends GlobalShadowStyleDirective implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<LeavingGateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { href: string }
  ) { 
    super();
  }

  ngOnInit() { }

  closeModal() {
    this.dialogRef.close();
  }

  confirmDepartureTime() {
    const windowFeatures = 'noreferrer,noopener';

    window.open(this.data.href, '_blank', windowFeatures);
    this.dialogRef.close();

  }
}
